import { Shift4Config } from "@src/models";

export const shift4Config: Shift4Config = {
  "1": {
    USDC: "USDC.ETH",
    NATIVE: "ETH",
  },
  "8453": {
    USDC: "USDC.BASE",
    NATIVE: "ETH",
  },
  "43114": {
    USDC: "USDC.AVAX",
    NATIVE: "AVAX",
  },
  "42161": {
    USDC: "USDC.ARBITRUM",
    NATIVE: "ETH",
  },
  "10": {
    USDC: "USDC.OPTIMISM",
    NATIVE: "ETH",
  },
  "137": {
    USDC: "USDC.POLYGON",
    NATIVE: "POL",
  },
  "11155111": {
    USDC: "USDC.ETH",
    NATIVE: "ETH",
  },
  "84532": {
    USDC: "USDC.BASE",
    NATIVE: "ETH",
  },
};
